<template v-if="this.$store.getters.Loaded">
    <div id="top" name="top" ref="top" class=" uk-section uk-position-z-index-negative uk-flex uk-flex-center uk-flex-middle uk-text-center uk-sticky" uk-sticky="overflow-flip: true; end: 100%" uk-height-viewport="" style="min-height: calc(100vh);">
        <div  class="uk-container uk-margin-large-top">
            <h1 v-if="this.$store.getters.GetMobile" class="uk-heading-large uk-animation-fade" uk-scrollspy="cls:uk-animation-fade;" uk-parallax="target: !.uk-section +* +*; end: 75%; y: -700; easing: 0;" style="transform: translateY(0px); will-change: transform; color:white;" v-html="this.$store.getters.GetText.anim.number[this.$store.getters.Lang]"></h1>            
            <h2 v-else class="uk-heading-large uk-animation-fade" uk-scrollspy="cls:uk-animation-fade;" uk-parallax="target: !.uk-section +* +*; end: 75%; y: -700; easing: 0;" style="transform: translateY(0px); will-change: transform; color:white;" v-html="this.$store.getters.GetText.anim.number[this.$store.getters.Lang]"></h2>            
            <h1 v-if="this.$store.getters.GetMobile" class="uk-heading uk-animation-fade"  uk-parallax="target: !.uk-section +* +*; end: 75%; y: -700; easing: 0;" style="transform: translateY(0px); will-change: transform; color:white;" v-html="this.$store.getters.GetText.anim.title[this.$store.getters.Lang]"></h1>
            <h2 v-else class="uk-heading uk-animation-fade"  uk-parallax="target: !.uk-section +* +*; end: 75%; y: -700; easing: 0;" style="transform: translateY(0px); will-change: transform; color:white;" v-html="this.$store.getters.GetText.anim.title[this.$store.getters.Lang]"></h2>
        </div>
    </div>
    <div class="uk-sticky-placeholder" style="height: 150% width: 100vw; margin: 0px;" hidden=""></div>
        <div class="uk-section uk-position-z-index-negative uk-flex uk-flex-center uk-flex-middle uk-text-center uk-sticky" uk-sticky="overflow-flip: true; end: 100%" uk-height-viewport="" style="min-height: calc(100vh);">
            <div class="uk-container">
                <h2 v-if="this.$store.getters.GetMobile" class="uk-heading" uk-scrollspy="cls:uk-animation-fade;" uk-parallax="target: !.uk-section +* +*; end: 100%; y: -700; easing: 0;" style="transform: translateY(0px); will-change: transform; color:white;"  v-html="this.$store.getters.GetText.anim.orgs[this.$store.getters.Lang]"></h2>                
                <h3 v-else class="uk-heading uk-margin-bottom" uk-scrollspy="cls:uk-animation-fade;" uk-parallax="target: !.uk-section +* +*; end: 100%; y: -750; easing: 0;" style="transform: translateY(0px); will-change: transform; color:white;"  v-html="this.$store.getters.GetText.anim.orgs[this.$store.getters.Lang]"></h3>                
            </div>
        </div>
    <div class="uk-sticky-placeholder" style="height: 150%; width: 100vw; margin: 0px;" hidden=""></div> 
</template>
<script>
import WAVES from 'vanta/dist/vanta.waves.min.js'
import * as THREE from 'three';


export default {
  updated() {
    if (this.$store.getters.GetBlock.animWave){
        this.animUpgrade()
    }
  },
  mounted(){
    if (this.$store.getters.GetBlock.animWave){
    this.destroyVanta()
    this.animUpgrade()
    window.scrollBy(0, 0)
    }
  },
  beforeUnmount() {
    
    if (this.vantaEffect && this.$store.getters.GetBlock.animWave) {
      this.vantaEffect.destroy()
    }
  },
  methods: {
    //document.getElementById("top")
    colorToSigned24Bit(s) {
        return (parseInt(s, 16) << 8) / 256;
    }, 

    animUpgrade () {
        if (this.$store.getters.Loaded && this.$store.getters.GetBlock.animWave){
            var settings=this.$store.getters.Animation.waves
            //let settings={
            //    color: 0x07476d,
            //    shininess: 50,
            //    minHeight: 200.00,
            //    minWidth: 200.00,
            //    scale: 0.00,
            //    scaleMobile: -0.00,                
            //    DoubleSide: false,
            //    baseSpeed: 0.50,
            //    mobileSpeed: 1,
            //    baseHeight: 50, 
            //    mobileHeight: 10 
            //} 
            let wave=this.$store.getters.GetMobile?settings.baseHeight:settings.mobileHeight
            let speed=this.$store.getters.GetMobile?settings.mobileSpeed:settings.baseSpeed

            let default_settings={
                el: this.$refs.top,
                THREE: THREE, 
                color: this.colorToSigned24Bit(settings.color),               
                mouseControls: false,
                touchControls: false,
                gyroControls: false,
                waveHeight: wave,
                waveSpeed: speed, 
                
            }            
            this.vantaEffect = WAVES(default_settings,settings)
        }
        
    },
    destroyVanta(){
        if (this.vantaEffect && this.$store.getters.GetBlock.animWave) {
        this.vantaEffect.destroy()
    }
    }
    }

}


</script>